console.log("Zyris Test");
const API_KEY = 'AIzaSyArb7B5_6TT02Pv_JZ1QEF5gUkOh9prvcU';
const API_ID = '388580757882-80rkvitr82jvl9rfbnj6aqkl01peqnma.apps.googleusercontent.com';
const PLAYLIST_ID = 'PLClz2XAwoK4Xtp8hzCFHuQ07Ho-EcoMFC';

var videoVisible = 1;
var maxVideoVisible = 50;

const playlistItems = [];
const playlist = document.getElementsByClassName("playlist")[0];

/*
// From Google API Docs
function initGAPIClient() {
  gapi.load('client:auth2', function(){
    console.log('auth loaded');
    gapi.auth2.init({
      client_id: API_ID
    });
    loadClient().then(getPlaylistItems); 
  });
};

// From Google API Docs
function loadClient() {
  gapi.client.setApiKey(API_KEY);
  return gapi.client.load("https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest")
    .then(
    function() { 
      console.log("GAPI client loaded for API"); },
    function(err) { 
      console.error("Error loading GAPI client for API", err); 
    });
}

function getPlaylistItems(pageToken) {
    console.log("Playlist Items");
    return gapi.client.youtube.playlistItems.list({
      "part": "snippet,contentDetails",
      "maxResults": 50, // This is the maximum available value, according to the google docs
      "playlistId": PLAYLIST_ID,
      pageToken
    })
      .then(function(response) {
      const { items, nextPageToken } = response.result;
      
      // The items[] is an array of a playlist items.
      // nextPageToken - if empty - there are no items left to fetch
      
      playlistItems.push(...items);
      
      // It's up to you, how to handle the item from playlist. 
      // Add `onclick` events to navigate to another video, or use another thumbnail image quality 
      var index = 1;
      items.forEach(function(item) {
          const thumbnailItem = createPlaylistItem(item, index);
          playlist.appendChild(thumbnailItem);
          index++;
        });
      
      maxVideoVisible = index - 3;
      

      // Recursively get another portion of items, if there any left
      if (nextPageToken) {
        getPlaylistItems(nextPageToken);        
      }
    },
  function(err) { console.error("Execute error", err); });
}

function createPlaylistItem(i, index) {
  const item = document.createElement('div');
  item.classList.add('playlist-item');
  item.style.background = `url(https://i.ytimg.com/vi/${i.snippet.resourceId.videoId}/mqdefault.jpg) no-repeat center`;
  item.style.backgroundSize = 'contain';
  item.id = index.toString();
  item.addEventListener("click", clickPlaylistItem);
  return item;
};

function clickPlaylistItem(e) {
  document.getElementById('yt-iframe').setAttribute("src","https://www.youtube.com/embed?listType=playlist&list="+PLAYLIST_ID+"&autoplay=1&index=" + e.target.id.toString());
}

// Before doing any action with the API ->
initGAPIClient();

function goUp(){
  if (videoVisible > 1){
    videoVisible--;
    document.getElementById(videoVisible.toString()).style.height = "90px";
  }
}
function goDown(){
    if (videoVisible < maxVideoVisible){
      document.getElementById(videoVisible.toString()).style.height = "0px";
     videoVisible++;    
  }  
}

// Product Form Warranty Add To Cart
 function addWarrantyItem() {
          let singleWarrantyID;
          let warrantyQty;
          if (jQuery('#single-warranty-input').is(':checked')) {
            singleWarrantyID = jQuery('#single-warranty-input').data('product-id-cart');
            warrantyQty = jQuery('.quantity-input__input').val();
            console.log(singleWarrantyID);
            console.log(warrantyQty);
            setTimeout(function(){
              jQuery.ajax({
                url:'/cart/add.js',
                type: 'post',
                dataType: 'json',
                data: { quantity: warrantyQty,id: singleWarrantyID }
              });
            }, 500);
          }
        }


$(function() {
    console.log( "Jquery ready!" );
});
*/